/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * Typescript doesn't realize theme is passed to props throught the theme context, and
 * throws an error when attempting to use theme.body and theme.text. This is a .js file
 * as a workaround.
 */
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    min-height: 100vh;
    margin: 0;
    padding: 0;
    font-family: 'VySans', BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;

    ::-webkit-scrollbar {
      display: none;
    }

    &.no-scroll {
      overflow: hidden;
    }
  }
`;

export default GlobalStyles;
